import { render, staticRenderFns } from "./public-commercial-contract-block.vue?vue&type=template&id=11321958&"
import script from "./public-commercial-contract-block.vue?vue&type=script&lang=js&"
export * from "./public-commercial-contract-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11321958')) {
      api.createRecord('11321958', component.options)
    } else {
      api.reload('11321958', component.options)
    }
    module.hot.accept("./public-commercial-contract-block.vue?vue&type=template&id=11321958&", function () {
      api.rerender('11321958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/commercial/partials/public-commercial-contract-block.vue"
export default component.exports